import { CrudRouter, AutoRouter } from "javaee-fre";

const routers = [
    {
        path: 'home/admin/my/tenant/video/category',
        component: CrudRouter,
        meta: {
            listItemActions: [{
                label: '置顶', icon: 'arrow_upward', func(cfg) {
                    let self = this;
                    self.$axios.get(`/home/admin/my/tenant/video/category/top/set/${cfg.item.id}`).then(() => {
                        self.refresh(); self.$status('置顶成功', 'success');
                    })
                }
            }, {
                label: '取消置顶', icon: 'arrow_downward', func(cfg) {
                    let self = this;
                    self.$axios.get(`/home/admin/my/tenant/video/category/top/cancel/${cfg.item.id}`).then(() => {
                        self.refresh();
                        self.$status('取消置顶成功', 'success');
                    });
                }
            }],
            listItemFilter(i, acts) {
                if (!i.topTs) {
                    this.delAction(acts, "icon", "arrow_downward");
                }
            }
        }
    },
    {
        path: 'home/admin/my/tenant/video/video',
        component: AutoRouter,
        meta: {
            acceptEmptyActive: true,
            tree: {
                title: '分类', disableActiveFirst: true, label(i) { return i.label }, id(i) { return i.id }, hasChildren() { return false },
                url() {
                    return '/home/admin/my/tenant/video/category/list/0/100';
                }
            },
            crud: {
                url: '/home/admin/my/tenant/video',
                genParams(i) { return i ? { _cid: i.id } : {} },
                selectStyle: 'multi',
                listActions: [
                    {
                        label: '移动到新分类', whereSel: true, func() {
                            let self = this, ids = Object.keys(self.selected() || {});
                            if (!ids || ids.length == 0) {
                                return
                            }

                            self.$axios.get('/home/admin/my/tenant/video/category/list/0/100').then(r => {
                                self.$dialog.select('选择分类', { width: 400, items: r.data.message, itemLabel: 'label', itemVal: 'id' }, [{
                                    label: '确认', color: 'primary', func(cid) {
                                        if (!cid) { return }
                                        self.$axios.get(`/home/admin/my/tenant/video/change/category/${ids.join('_')}/${cid}`).then(() => {
                                            self.refresh(false, true);
                                            self.$status('移动完成', 'success');
                                        });
                                    }
                                }])
                            })
                        }
                    }
                ],
                listItemActions: [
                    {
                        label: '置顶', icon: 'arrow_upward', func(cfg) {
                            let self = this;
                            self.$axios.get(`/home/admin/my/tenant/video/top/set/${cfg.item.id}`).then(() => {
                                self.refresh();
                                self.$status('置顶成功', 'success');
                            })
                        }
                    }, {
                        label: '取消置顶', icon: 'arrow_downward', func(cfg) {
                            let self = this;
                            self.$axios.get(`/home/admin/my/tenant/video/top/cancel/${cfg.item.id}`).then(() => {
                                self.refresh();
                                self.$status('取消置顶成功', 'success');
                            });
                        }
                    },
                    {
                        label: '播放', icon: 'play_arrow', func(cfg) {
                            let self = this;
                            self.$axios
                                .get(`/home/admin/my/tenant/video/cc/url/${cfg.item.id}`)
                                .then((r) => {
                                    if (
                                        r.data &&
                                        r.data.status == "ok" &&
                                        r.data.message
                                    ) {
                                        self.$dialog.component(
                                            cfg.item.label,
                                            "cc-video-viewer",
                                            {
                                                movieUrl: r.data.message,
                                            }
                                        );
                                    }
                                });
                        }
                    }, {
                        label: '题目', icon: 'spellcheck', func(cfg) {
                            this.$router.push(`/console/home/admin/my/tenant/video/video/question/${cfg.item.id}`)
                        }
                    }],
                listItemFilter(i, acts) {
                    if (!i.topTs) {
                        this.delAction(acts, "icon", "arrow_downward");
                    }
                }
            }
        },
        children: [{
            path: 'question/:_vid', component: CrudRouter, meta: { url: '/home/admin/my/tenant/video/question', name: '题目管理' }
        }]
    },
    {
        path: 'home/admin/my/tenant/video/album',
        component: CrudRouter,
        meta: {
            listItemActions: [{
                label: '专辑视频', icon: 'list', func(cfg) {
                    this.$router.push(`/console/home/admin/my/tenant/video/album/item/${cfg.item.id}`);
                }
            }]
        },
        children: [
            {
                path: 'item/:_albumId', component: CrudRouter, meta: {
                    name: '专辑视频', url: '/home/admin/my/tenant/video/album/item',
                    editable: false,
                    listActions: [{
                        label: '添加视频', func() {
                            let self = this;
                            self.$dialog.crud('选择视频', {
                                url: '/home/admin/my/tenant/video', editable: false, deleteable: false, selectStyle: 'multi'
                            }, [{
                                label: '确认添加', color: 'primary', func(sel) {
                                    if (!sel) return;
                                    let ids = Object.keys(sel);
                                    if (ids.length == 0) return;
                                    self.$axios.get(`/home/admin/my/tenant/video/album/add/items/${self.$route.params._albumId}?vids=${ids.join('_')}`).then(() => {
                                        self.refresh();
                                        self.$status('添加成功', 'success');
                                    });
                                }
                            }]);
                        }
                    }],
                    listItemActions: [{
                        label: '置顶', icon: 'arrow_upward', func(cfg) {
                            let self = this;
                            self.$axios.get(`/home/admin/my/tenant/video/album/item/top/set/${cfg.item.id}`).then(() => {
                                self.refresh();
                                self.$status('置顶成功', 'success');
                            })
                        }
                    }, {
                        label: '取消置顶', icon: 'arrow_downward', func(cfg) {
                            let self = this;
                            self.$axios.get(`/home/admin/my/tenant/video/album/item/top/cancel/${cfg.item.id}`).then(() => {
                                self.refresh();
                                self.$status('取消置顶成功', 'success');
                            });
                        }
                    }, {
                        label: '播放', icon: 'play_arrow', func(cfg) {
                            let self = this;
                            self.$axios
                                .get(`/home/admin/my/tenant/video/cc/url/${cfg.item.videoId}`)
                                .then((r) => {
                                    if (
                                        r.data &&
                                        r.data.status == "ok" &&
                                        r.data.message
                                    ) {
                                        self.$dialog.component(
                                            cfg.item.label,
                                            "cc-video-viewer",
                                            {
                                                movieUrl: r.data.message,
                                            }
                                        );
                                    }
                                });
                        }
                    }],
                    listItemFilter(i, acts) {
                        if (!i.topTs) {
                            this.delAction(acts, "icon", "arrow_downward");
                        }
                    }
                }
            }
        ]
    }
]
export default {
    routers: routers
}